<app-reports
  title="Client Prescriber Check Reports"
  [reportsUrl]="reportsUrl" />
